<div *ngIf="section" class="generic-items-section">
  <!-- Technical Description Section -->
  <div class="technical-description section">
    <p class="subtitle">{{'quotation.technicalDescription' | translate}}</p>
    <!-- <ngx-editor-menu [editor]="technicalDescriptionEditor" [toolbar]="toolbar"> </ngx-editor-menu> -->
    <div class="refresh">
      <app-document-editor-menu [editor]="technicalDescriptionEditor" [toolbar]="toolbar">
      </app-document-editor-menu>
      <div class="actions">
        <button class="fas fa-save" (click)="onSaveTemplateClick()">
        </button>
        <button class="fas fa-folder-open" (click)="showTechnicalDescriptionModal = true">
        </button>
        <button (click)="reset(section.sectionName)" class="fas fa-undo">
        </button>
      </div>
    </div>
    <div id="editor-container" [ngClass]="getSectionClass(section.sectionName)">
      <ngx-editor [editor]="technicalDescriptionEditor" [(ngModel)]="section.technicalDescription.value"
        (ngModelChange)="onEditorChange($event)">
      </ngx-editor>
    </div>
  </div>

  <!-- Items Table Section -->
  <div class="items-section section">
    <p class="subtitle">{{'quotation.items' | translate}}</p>

    <!-- Button to trigger the item picker modal -->
    <teiasoft-button *ngIf="uncategorizedItems.length > 0" [text]="'enquiryBook.addItems' | translate"
      (onClick)="openItemPicker()" [disabled]="false"></teiasoft-button>

    <p *ngIf="section.items.length == 0 && uncategorizedItems.length == 0">{{ 'quotation.noItemsData' | translate }}</p>


    <!-- <p *ngIf="section.items.length == 0">{{ "enquiryBook.noData" | translate}}</p> -->
    <div class="table-container">
      <table *ngIf="section.items.length > 0" class="items-table">
        <thead>
          <tr>
            <th></th>
            <th *ngFor="let field of section.fields"
              [ngStyle]="{'min-width': field.label === 'deliveryDate' ? '8vw' : 'auto'}">
              {{getPropertyLabel(field.label) }}
              <span *ngIf="isFieldHideable(field)">
                <input type="checkbox" [checked]="!field.hidden" (change)="toggleFieldVisibility(field)" />
              </span>

            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items.sort(sortByCustomerItemNo)">
            <td>
              <i class="fal fa-trash-alt tg-custom-icon" (click)="onRemoveItem(item)" style="cursor: pointer;"></i>
            </td>
            <td *ngFor="let field of section.fields">
              <ng-container *ngIf="field.label !== 'remark' ">
                <span *ngIf="field.label in item">
                  {{ !!field.render ? field.render(item,formatWeeks) : (getNestedValue(item, field.label) || '-')
                  }}
                </span>
              </ng-container>
              <!-- <ng-container *ngIf="field.label === 'deliveryDate'"> -->
              <!-- <mat-form-field >
                  <input matInput [matDatepicker]="picker" [(ngModel)]="item.deliveryDate">
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field> -->
              <!-- <teiasoft-datetime [value]="''+item.deliveryDate" [type]="'date'" [isRequired]="false"
                  [dateFormat]="globals!.dateFormat!" [size]="'s'"
                  (onChange)="onChangeDeliveryDate($event, item)"></teiasoft-datetime> -->

              <!-- (onChange)="onChangeCustomerDeliveryDate($event)" -->
              <!-- <input type="date" [(ngModel)]="item.deliveryDate" />  -->
              <!-- </ng-container> -->

              <ng-container *ngIf="field.label === 'remark'">
                <input type="text" [(ngModel)]="item.remark" /> <!-- Editable remarks -->
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>
  <div class="total-check-container">
    <div>
      <input type="checkbox" [(ngModel)]="section.showTotalWeight" (ngModelChange)="onCheckboxChange('showTotalWeight')"
        [disabled]="!hasSameUom('totalWeightUom')" />
      <span>{{ 'quotation.showTotalWeight' | translate }}</span>
    </div>
    <div>
      <input type="checkbox" [(ngModel)]="section.showTotalLength" (ngModelChange)="onCheckboxChange('showTotalLength')"
        [disabled]="!hasSameUom('totalLengthUom')" />
      <span>{{ 'quotation.showTotalLength' | translate }}</span>
    </div>
    <div>
      <input type="checkbox" [(ngModel)]="section.showTotalPrice" (ngModelChange)="onCheckboxChange('showTotalPrice')"
        [disabled]="!hasSameUom('totalPriceUom')" />
      <span>{{ 'quotation.showTotalPrice' | translate }}</span>
    </div>
  </div>

  <!-- Free Text Section -->
  <div class="free-text section">
    <p class="subtitle">{{'quotation.freeText' | translate}}</p>
    <app-document-editor-menu [editor]="freeTextEditor" [toolbar]="toolbar">
    </app-document-editor-menu>
    <ngx-editor [editor]="freeTextEditor" [(ngModel)]="section.freeText">
    </ngx-editor>
  </div>
</div>

<div *ngIf="isItemPickerOpen" class="item-picker-modal">
  <h3>{{'quotation.selectItems' | translate}}</h3>

  <div style="overflow: auto;">
    <teiasoft-grid [dataSet]="uncategorizedItems" [selectable]="true" [multiSelection]="true" [sortable]="true"
      [showDeleteIcon]="false" [showEditIcon]="false" [theme]="theme" [showFooter]="false"
      [columnsToShow]="columnsToShowItem" (rowsSelected)="onRowsSelected($event)" [selectedRow]="selectedItems"
      [disableAllSelection]="false">
    </teiasoft-grid>
  </div>

  <div class="td-cnt-btn">
    <teiasoft-button (onClick)="addSelectedItems()" class="mr-5" [text]="'commons.save' | translate"
      [type]="'tb-secondary'"></teiasoft-button>
    <teiasoft-button (onClick)="closeItemPicker()" class="mr-5" [type]="'tb-cancel'"
      [text]="'commons.cancel' | translate"></teiasoft-button>
  </div>
</div>

<app-modal-technical-description *ngIf="showTechnicalDescriptionModal"
  (closeModal)="showTechnicalDescriptionModal = false"
  (onSelectedTemplate)="onLoadTemplate($event)"></app-modal-technical-description>




<!-- MODAL -->
<ng-template #promptTemplateName let-dialogRef="dialogRef">
  <div class="dialog">
    <div class="td-cnt-title">
      <span class="te-title">
        {{ 'quotation.addTechnicalDescriptionTemplate' | translate }}
      </span>
    </div>
    <div class="td-cnt-body-ds">
      <teiasoft-input [type]="'text'" [labelText]="'quotation.templateName' | translate" [isMobile]="isMobile"
        [isRequired]="true" [disabled]="false" [value]="newTemplateName" (onInput)="onInputTemplateName($event)"
        [readOnly]="false"></teiasoft-input>
    </div>
    <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
      <teiasoft-button class="ml-5" (onClick)="dialogRef.close()" [text]="'commons.cancel' | translate"
        [isMobile]="isMobile"></teiasoft-button>
      <teiasoft-button class="ml-5" (onClick)="dialogRef.close(newTemplateName)" [text]="'commons.add' | translate"
        [isMobile]="isMobile"
        [disabled]="!newTemplateName || newTemplateName === '' || !newTemplateIsValid"></teiasoft-button>
    </div>
  </div>
</ng-template>
